import { render } from "./FormsView.vue?vue&type=template&id=603269ca"
import script from "./FormsView.vue?vue&type=script&lang=js"
export * from "./FormsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__